import { Checkbox, Switch, Text, useAlert, HStack, VStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useEffect } from 'react';

import { SendingChannelsController } from '../../../../../../../../hooks/useSendingChannels';

export enum ChannelOptionSelection {
  Portal = 1,
  Legacy = 2,
}

export const useChannelOptionsSelectionComponent = (
  sendingChannelsController: SendingChannelsController,
  isManager: boolean = false
) => {
  const { alert } = useAlert();
  const {
    onChannelSelectChange,
    onClearAllSelection,
    sendingChannelsOptions,
    sendingChannelsSelected,
  } = sendingChannelsController;

  useEffect(() => {
    if (isManager) {
      onClearAllSelection(['email']);
    }
  }, [isManager, onClearAllSelection]);

  const portalContent = useBreakpointValue({
    base: (
      <VStack space="inline.xxxs">
        {sendingChannelsOptions?.map((option) => (
          <HStack alignItems={'center'} justifyContent={'space-between'} key={option.label}>
            <Text>{option.label}</Text>
            {!option.isInvalid && (
              <Switch
                onToggle={(value: boolean) => onChannelSelectChange(option.value, value)}
                isChecked={sendingChannelsSelected?.includes(option.value)}
                isDisabled={!!option.disabled}
              />
            )}
            {option.isInvalid && (
              <Switch
                isChecked={false}
                offTrackColor={Utils.ColorToken.WithOpacity('feedback.error.default', 0.5)}
                offThumbColor={Color['feedback.error.default']}
                onToggle={() => {
                  alert(
                    {
                      icon: 'Warning',
                      iconColor: 'feedback.attention.default',
                      title: 'Atenção',
                      description: option.invalidMessage,
                    },
                    () => {}
                  );
                }}
              />
            )}
          </HStack>
        ))}
      </VStack>
    ),
    md: (
      <HStack space="inline.quarck" w="full" alignItems="center" justifyContent="space-between">
        <Text>Selecione o canal de envio</Text>

        <Checkbox
          hasError={!sendingChannelsSelected.length}
          testId="channel-checkbox"
          options={sendingChannelsOptions}
          onChange={onChannelSelectChange}
          selectedValues={sendingChannelsSelected}
          optionPadding={{ bottom: 0, left: 'inline.xs' }}
        />
      </HStack>
    ),
  });

  if (isManager) {
    return null;
  }

  return portalContent;
};
